import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import NotfoundPage from "./components/status/NotfoundPage";
import LandingPage from "./components/LandingPage/LandingPage";
import About from "./components/About/About";
import Simulation from "./components/Simulation/Simulation";
import Space from "./components/Space/Space";
import Schedule from "./components/Schedule/Schedule";
import Contact from "./components/Contact/Contact";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import styled from "styled-components";

function App() {
  return (
    <div>
        <Suspense fallback={<div>Loading..</div>}>          
          <NavBar />
            <Container>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/space" element={<Space />} />
              <Route path="/schedule" element={<Schedule />} />              
              <Route path="/contact" element={<Contact />} />
              <Route path="/simulation" element={<Simulation />} /> 
              <Route path="*" element={<NotfoundPage />} />
            </Routes>
            </Container>
            <Footer />
      </Suspense>
    </div>
  );
}

const Container = styled.div`
  padding-Top: 60px;
  min-Height: calc(100vh - 40px);
  /* max-Width: 1000px; */
  /* height: 100%; */
  width: 100%;
  margin: auto;
  text-align: center;
  `;
export default App;
